export class OfficePhone {
    phoneTypeDescription!: string | null;
    phoneNumber!: string;
    phoneType!: number;
    fieldName!: string;
    phoneNumberTypeId!: number;
    isDisplay: boolean = true;
    order!: number;
    phInvalid?: boolean;
    name?: string;
    editable?: boolean;
    updateNo?: boolean;
    typeId?: string;
    typeInvalid?: boolean;
    isNumberDeleted? : boolean = false;
    selected? : boolean;
    areaCode! : string;
    displayOnPublicSite!:boolean;
    officePhoneID!: number;
    pcNumber!:string;
    phoneNumberTypeText!:string;
    phoneTypeName!:string;
    user!:string;
    isDataModified? : boolean;
}

export class GetOfficePhoneNo {
    dName!: string;
    isDisplay: boolean = true;
    order!: number;
    phoneNumber!: string;
    phoneNumberTypeId!: number;
    phoneType!: null;
    phoneTypeDescription!: string;
    invalid?: boolean
}

export class OfficeDetails {
    officeName!: string;
    officeNumber: any;
    division!: string;
    officeAddress: OfficeAddress = new OfficeAddress();
    officeManagers: OfficeManagers[] = [];
}

export class OfficeAddress {
    addressLine1!: string;
    addressLine2!: string;
    city!: string;
    state!: string;
    zipCode!: string;
    county: any;
}

export class OfficeManagers {
    agentNumber!: string;
    managerName!: string;
    managerEmail!: string;
    managerType!: string;
    displayOrder!: number;
}

export class MlsOfficeCompanyDetails {
    officeMlsId!: number;
    mlsShortName!: string;
    officeMlsNumber!:  string;
    mlsCompanyId!: number;
    mlsFullName!: string;
    entityState!: string;
    selected! :boolean;
}

export class MlsAgentDetails{
    agentNumber!: string;
    agentMlsNumber!: string;
    agentName!: string;
    pcNumber!: string;
    mlsCompanyId!: number;
    mlsCompanyShortName!: string;
    isPublish!: boolean;
    newsiteUrl : any;
    mlsNameList : string[] = [];
    mlsAgentNumber : any[] = [];
}

export class GetBio {
    officeDescription!: string;
    officeHeadLine!: string;
    officeURL!: string;
}

export class GetOfficeComp{
    agentId!:string;
    AgentName!:string;
    mlsId!:string;
    mlsCompanyId!:number;
    status!:string;
    propertyType!:string;
    Address!:string;
    Price!:string;
    SaleOrRental!:string;
    dateAdded!:string;
    dateUpdated!:string;
    commissionUnitId!: number;
    comp!:number;
    remarks!:string;
    isExist!:number;
    updated?: boolean;
    disableTxtAmt?: boolean;
    disableTxtRem?:boolean;
    isAgreementSaved?:boolean;
    isFileUpload?:boolean;
    uploadedFile?: File;
}